import type { VariantLoadingSizeProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { getSizeClass, SR_LOADING_TEXT } from '../helper';
import '../index.less';

function PulseDotLoading({ className, size = 'md' }: VariantLoadingSizeProps, ref: React.Ref<HTMLDivElement>) {
  return (
    <div ref={ref} className={cn('wg-variant-loading__pulse-dot', getSizeClass(size), className)}>
      <span className="wg-variant-loading__sr-only">{SR_LOADING_TEXT}</span>
    </div>
  );
}

const PulseDotLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingSizeProps>(PulseDotLoading);
PulseDotLoadingComponent.displayName = 'PulseDotLoading';

export default PulseDotLoadingComponent;
